import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function Promise() {
  return <section className="bg-forest-green py-12 md:py-16 px-4 sm:px-6 lg:px-8 text-white relative overflow-hidden" data-id="element-154">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-sage-green/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-155" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gold/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-156" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="inline-flex items-center gap-2 bg-gold/20 text-gold px-4 py-2 rounded-full text-sm font-semibold uppercase tracking-widest mb-8" data-id="element-159">
            <Sparkles className="w-4 h-4" data-id="element-160" />
            The Promise
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-10 leading-tight text-white" data-id="element-161">
            What If the Solution Cost Less Than $15 a Week and Was Available at
            Any Grocery Store?
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-162">
          <FadeIn delay={0.2} data-id="element-163">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-164">
              We're not talking about a restrictive diet. We're not talking
              about intense exercise. We're not talking about expensive
              supplements.
            </p>
          </FadeIn>

          {/* Gold checkmark bullets */}
          <FadeIn delay={0.25} data-id="element-165">
            <div className="flex flex-col items-center gap-4 py-4" data-id="element-166">
              <div className="flex items-center gap-3 text-lg md:text-xl" data-id="element-167">
                <span className="text-[#C9A84C] text-xl" data-id="element-168">✦</span>
                <span className="text-gray-200 font-medium" data-id="element-169">
                  No restrictive diet
                </span>
              </div>
              <div className="flex items-center gap-3 text-lg md:text-xl" data-id="element-170">
                <span className="text-[#C9A84C] text-xl" data-id="element-171">✦</span>
                <span className="text-gray-200 font-medium" data-id="element-172">
                  No intense exercise
                </span>
              </div>
              <div className="flex items-center gap-3 text-lg md:text-xl" data-id="element-173">
                <span className="text-[#C9A84C] text-xl" data-id="element-174">✦</span>
                <span className="text-gray-200 font-medium" data-id="element-175">
                  No expensive supplements
                </span>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-176">
            <div className="bg-white/10 border border-white/15 backdrop-blur-sm rounded-2xl p-8 my-4" data-id="element-177">
              <p className="font-bold text-2xl text-gold leading-snug" data-id="element-178">
                We're talking about 10 specific ingredients, prepared in a
                specific way, in a specific order, for 7 days.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-179">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-180">
              Ingredients that have been in grandmothers' kitchens for
              centuries. But that modern functional science has just explained
              exactly why they work.
            </p>
          </FadeIn>
        </div>

        {/* Styled quote block */}
        <FadeIn delay={0.5} data-id="element-181">
          <div className="mt-10 px-4" data-id="element-182">
            <div className="w-full h-px bg-[#C9A84C]/40 mb-8" data-id="element-183" />
            <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-snug" style={{
            color: '#C9A84C'
          }} data-id="element-184">
              "Just 10 ingredients.
              <br data-id="element-185" />
              7 days.
              <br data-id="element-186" />
              Less than $15 a week."
            </p>
            <div className="w-full h-px bg-[#C9A84C]/40 mt-8" data-id="element-187" />
          </div>
        </FadeIn>

        {/* Decorative divider */}
        <FadeIn delay={0.6} data-id="element-188">
          <div className="flex items-center justify-center gap-3 mt-10" data-id="element-189">
            <div className="w-12 h-px bg-gold/40" data-id="element-190" />
            <div className="w-2 h-2 rounded-full bg-gold/60" data-id="element-191" />
            <div className="w-12 h-px bg-gold/40" data-id="element-192" />
          </div>
        </FadeIn>
      </div>
    </section>;
}